import { IconType, defaultProps } from './types';

/**
 * Icono Search
 */
export const Star = ({
  className,
  width,
  height,
  color = defaultProps.color,
}: IconType): JSX.Element => (
  <svg
    {...(className ? { className: className } : {})}
    {...(width ? { width: width } : {})}
    {...(height ? { height: height } : {})}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
  >
    <path
      d="m16 0 3.592 11.056h11.625l-9.405 6.833 3.593 11.055L16 22.112l-9.405 6.832 3.593-11.055-9.405-6.833h11.625L16 0Z"
      fill={color}
    />
  </svg>
);
